module.exports = __webpack_public_path__ + "static/media/4.5a238284.svg";